import { TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomInverterResult } from './inverter.model';

export interface DeviceModbusInfo {
  [key: string]: {
    [key: string]:
      | {
          type: 'data';
          value$: Observable<string | BigInt | number | CustomInverterResult | null | undefined>;
          name: string;
          hide?: boolean;
          hide$?: Observable<boolean>;
          size?: number;
          bgColorClass: string;
        }
      | {
          type: 'component';
          value$: Observable<
            | {
                component: TemplateRef<any>;
                context: { [key: string]: any };
              }
            | undefined
            | null
          >;
        };
  };
}

export enum InverterSettingsCodeV3 {
  AntiRefluxControl = 1,
  AntiRefluxPower,
  BatteryActiveControl,
  BatteryActiveOneShot,
  BatteryCommunicationAddress,
  BatteryCommunicationProtocol,
  BatteryConfigID,
  BatteryConfigurationControl,
  BatteryCurrentChargeLimit,
  BatteryCurrentDischargeLimit,
  BatteryDepthOfDischarge,
  BatteryEndOfDischarge,
  BDUConfigInquire,
  BMSConfigInquire,
  EnergyStorageModeControl,
  EpsControl,
  IVCurveScanControl,
  IVCurveScanPeriod,
  Language,
  ParallelAddress,
  ParallelControl,
  ParallelMasterSlave,
  PassiveManualBlo,
  PassiveManualBup,
  PassiveManualGdes,
  PCCSampleMode,
  PCUConfigInquire,
  PVInputModeSelection,
  RS485ConfigAddress,
  RS485ConfigBaud,
  RS485ConfigParityBit,
  RS485ConfigStopBit,
  TimingChargeEnd,
  TimingChargePower,
  TimingChargeStart,
  TimingControl,
  TimingDischargeEnd,
  TimingDischargePower,
  TimingDischargeStart,
  TimingId,
  TimingOffOnControl,
  TimingRsvd1,
  TimingRsvd2,
  TimingRsvd3,
  TimingRsvd4,
  TouChargeEnd,
  TouChargePower,
  TouChargeStart,
  TouChargeTargetSoc,
  TouExecutedDateEnd,
  TouExecutedDateStart,
  TouExecutedDayOfWeek,
  TouId,
  TouOnOffControl,
  UnbalancedSupportControl,
  /**
   * Write all system time registers (year, month, day, hour, minute, second)
   * and apply with a single multi-register write.
   */
  SysTimeConfig,
  /**
   * Purchase power limit enable control (0x106A)
   * 0: disabled, 1: enabled
   */
  PurchasePowerLimitEnable,
  /**
   * Purchase power limit value (0x106B)
   * Value in 0.1kW units (e.g., 30 = 3000W)
   */
  PurchasePowerLimitValue,
}

export enum InverterSettingsCodeV4 {
  BleCommunicationType = 1,
  PLCCommunicationType,
  UsbCommunicationType,
  Rs485CommunicationType1,
  Rs485CommunicationType2,
  StartUpgradeFromUsb,
}

export enum InverterSettingsCodeV2 {
  BatteryCommunicationProtocol,
  BatteryMaximumChargeVoltage,
  BatteryMaximumChargeCurrent,
  BatteryOverVoltageProtection,
  BatteryMinimumDischargeVoltage,
  BatteryMaximumDischargeCurrent,
  BatteryUnderVoltageProtection,
  BatteryDepthOfDischarge,
  BatteryDodOffOnGridMode,
  BatteryEpsDischargeBuffer,

  ControlEPS,
  ControlInputMode,
  ControlAntiReflux,
  ControlAntiRefluxPower,
  ControlBatteryActivation,
  ControlForceBatteryActivation,
  ControlLogicalInterface,
  ControlCTDirectionLock,
  ControlCTCalibrationPower,
  ControlBatteryUninterruptibleEnable,

  ControlWorkMode,
  ControlTimeshareTariffRuleNumber,
  ControlTimeOfUseTariffsCompulsoryChargingStartTime,
  ControlTimeOfUseTariffsMandatoryChargingEndTimes,
  ControlTimeOfUseTariffsMandatoryChargingCutOffSOCs,
  ControlTimeOfUseTariffsMandatoryChargingPower,
  ControlTimeSharingTariffRuleStartDate,
  ControlTimeSharingTariffRuleEndDate,
  ControlTimeSharingTariffRuleEffectiveDate,
  ControlTimeSharingTariffRuleEnable,
  ControlTimingChargeStart,
  ControlTimingChargeEnd,
  ControlTimingDischargeStart,
  ControlTimingDischargeEnd,
  ControlTimingChargePower,
  ControlTimingDischargePower,
  ControlPassiveModeHeartbeat,
  ControlPassiveModeStandby,
  ControlPassiveModeDischarge,
  ControlPassiveModeCharge,
  ControlPassiveModeAuto,
};
